function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIconCheckbox2C20 = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 20 20"
}, props), /*#__PURE__*/React.createElement("g", {
  "data-name": "Ellipse 11",
  style: {
    fill: "#fff",
    stroke: "#e9e9e9"
  }
}, /*#__PURE__*/React.createElement("circle", {
  cx: 10,
  cy: 10,
  r: 10,
  stroke: "none",
  style: {
    stroke: "none"
  }
}), /*#__PURE__*/React.createElement("circle", {
  cx: 10,
  cy: 10,
  r: 9.5,
  style: {
    fill: "none"
  }
})), /*#__PURE__*/React.createElement("path", {
  d: "m-15860.7 1240.562 1.063-1.063 3.7 3.705 5.7-5.7 1.063 1.059-5.706 5.706.011.01-1.063 1.059z",
  "data-name": "Union 60",
  style: {
    fill: "#e9e9e9"
  },
  transform: "translate(15864.701 -1231.001)"
}));
export default SvgIconCheckbox2C20;